import React from 'react';
import { NavLink } from 'react-router-dom';
import { menuFor } from '../routes/menu';
import { ROLE_LABEL } from '../utils/roles';
import { BRAND_NAME } from '../utils/brand';
import { cn } from '../utils/cn';

function Sidebar({ user, isOpen, onClose }) {
  const menu = menuFor(user?.role);

  return (
    <>
      <aside className={cn('app-sidebar sidebar', isOpen && 'is-open')}>
        <div
          className="sidebar-brand"
          style={{ flexDirection: 'column', alignItems: 'center', gap: 4 }}
        >
          <img
            src="/fullLogo.png"
            alt={BRAND_NAME}
            className="brand-mark-img"
            style={{ height: 36, width: 'auto', objectFit: 'contain' }}
            draggable="false"
          />
          <span
            className="brand-sub"
            style={{ fontSize: 10, letterSpacing: '0.14em', textAlign: 'center' }}
          >
            {ROLE_LABEL[user?.role] || 'Portal'}
          </span>
        </div>

        <nav className="sidebar-nav">
          {menu.map((section, idx) => (
            <div
              key={section.label}
              style={{
                marginBottom: 'var(--s-3)',
                ...(idx > 0 ? {
                  paddingTop: 'var(--s-2)',
                  borderTop: '1px solid rgba(255,255,255,0.08)',
                } : {}),
              }}
            >
              <div className="sidebar-section-label">{section.label}</div>
              {section.items.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === '/dashboard'}
                    onClick={onClose}
                    className={({ isActive }) => cn('sidebar-link', isActive && 'is-active')}
                  >
                    <Icon size={18} />
                    <span>{item.label}</span>
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>

        <div className="sidebar-foot">
          <div>v1.0 · {BRAND_NAME}</div>
          <div style={{ marginTop: 4 }}>User-first health screening</div>
        </div>
      </aside>
      <div
        className={cn('sidebar-backdrop', isOpen && 'is-open')}
        onClick={onClose}
      />
    </>
  );
}

export default Sidebar;
